import React from 'react'
import { Knob } from 'primereact/knob'
import './Knob.scss'

const KnobChart = (props: { value: number; color: string; label: string; total: number }) => {
  return (
    <div className="d-flex knob-container">
      <Knob value={props.value} valueColor={props.color} min={0} max={props.total} />
      <p className="mt-4 knob-title" style={{ width: '150px' }}>
        {props.label}
      </p>
    </div>
  )
}

export default KnobChart
